import Blue from "~/core";
import Splide from '@splidejs/splide';

new Blue({
  name: "AviationHero",
  selector: "body",
  setup(body) {
    const shouldSetTimeout = document.querySelector("html").classList.contains("kentico-page-builder");
    if (shouldSetTimeout) {
      updateSplideMethodList({
        initAviationHeroSplide
      });
    } else {
      initAviationHeroSplide();
    }
  },
});

function initAviationHeroSplide() {

  var splideElement = document.querySelector('.aviation-hero__inner .splide');

  if (splideElement) {

    const aviationHeroSplide = new Splide(splideElement, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      autoplay: true,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      resetProgress: false
    });
    aviationHeroSplide.mount();

    var toggleButton = aviationHeroSplide.root.querySelector( '.splide__toggle' );

    if(toggleButton) {

      setInitialToggleButtonState(aviationHeroSplide, toggleButton);

      aviationHeroSplide.on( 'autoplay:play', function () {
        setToggleButtonToPause(toggleButton)
      } );
      
      aviationHeroSplide.on( 'autoplay:pause', function () {
        setToggleButtonToPlay(toggleButton)
      } );           
    }
  }
}

function setInitialToggleButtonState(aviationHeroSplide, toggleButton) {
  var Autoplay = aviationHeroSplide.Components.Autoplay;

  if (Autoplay.isPaused()) {
    setToggleButtonToPlay(toggleButton);
  }
  else {
    setToggleButtonToPause(toggleButton);
  }
}

function setToggleButtonToPause(toggleButton) {
  toggleButton.setAttribute('aria-label', 'Pause autoplay');
  toggleButton.querySelector('.splide__toggle-play').style.display = 'none';
  toggleButton.querySelector('.splide__toggle-pause').style.display = 'flex';
}

function setToggleButtonToPlay(toggleButton) {
  toggleButton.setAttribute('aria-label', 'Start autoplay');
  toggleButton.querySelector('.splide__toggle-play').style.display = 'flex';
  toggleButton.querySelector('.splide__toggle-pause').style.display = 'none';
}

function updateSplideMethodList(functionList) {
  if(window.splideMethods)
  {
    Object.assign(window.splideMethods, functionList);
  }
  else {
    window.splideMethods = functionList;
  }
}

